<template>
  <transition name="fade" mode="out-in">
    <div v-if="visible" class="small-modal" @click.self="hide(false)">
        <div class="modal-container">
            <div class="card-header">
                <h4>Ändra exporteringsdatum för markerade artiklar</h4>
            </div>
            <div class="card-body bg-white">
                <div class="form-group col-sm-12">
                    <label>{{ $t('Exporteringsdatum') }}</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <fa :icon="['fal','calendar-alt']" />
                            </span>
                        </div>
                        <date-picker v-model="exported_at" :config="dpConfig"/>
                    </div>
                </div>
                <p class="text-danger px-3">OBS! Exporteringsdatum kommer ändras för samtliga markerade artiklar!</p>
            </div>
            <div class="card-footer text-right">
                <button class="btn text-danger" @click="hide(false)" >Avbryt</button>
                <button class="btn btn-success" @click="saveExport">Spara</button>
            </div>
        </div>
    </div>
  </transition>
</template>

<script>
import axios from "axios";

export default {
    props: [
        'printableIds',
        'exportModal'
    ],

    data() {
        return {
            exported_at: '',
            errors: [],
            visible: false,
            dpConfig: {
              format: 'YYYY-MM-DD',
              useCurrent: false,
              locale : 'sv',
            }
        }
    },

    watch: {
        exportModal (n,o) {
            if (this.exportModal && !this.visible) this.show()
            else if (!this.exportModal && this.visible) this.hide(false)
        },
    },

    methods: {
        hide(reload) {
            this.visible = false;
            this.$emit('modal', reload);
        },
        show() {
            this.visible = true;
        },
        async saveExport() {
            let params = {
                printable_ids: this.printableIds,
                exported_at: this.exported_at,
                status: 'delivered',
            }

            const { data } = await axios.post('/api/printable/export',params);
            this.hide(true);
        },
    },


}
</script>

<style>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/EditExportModal.vue